export default __webpack_public_path__ + "static/media/access.4cce9580.PNG";